import { render, staticRenderFns } from "./bottom-popup.vue?vue&type=template&id=d56d5cdc&"
import script from "./bottom-popup.vue?vue&type=script&lang=js&"
export * from "./bottom-popup.vue?vue&type=script&lang=js&"
import style0 from "./bottom-popup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports